// enginePrecedence.js — FASE-12 E5-T02. A ORDEM DE PRECEDÊNCIA dos motores de
// execução no MESMO turno, num lugar puro/testável.
//
// O bug: no SessionWorkspace o gate do Modo Equipe (`if (teamModeOn)`) vinha ANTES
// do bloco do DAG executor e retornava. Com team ligado, um DAG APROVADO (dagTasks
// presente — intenção EXPLÍCITA do usuário que clicou Aprovar) ou uma proposta de
// plano (planPropose) era sequestrado pela equipe e nunca executava. A intenção
// explícita (plano aprovado / proposta) PREVALECE sobre o toggle de equipe.

/**
 * O turno deve rodar como EQUIPE (fan-out Hermes)? Só quando o toggle está ligado
 * E não há um DAG aprovado nem uma proposta de plano em curso — esses têm motores
 * próprios e vencem o toggle.
 * @param {boolean} teamModeOn
 * @param {{ dagTasks?: unknown, planPropose?: boolean }} turn
 * @returns {boolean}
 */
export function shouldRunTeamTurn(teamModeOn, { dagTasks = null, planPropose = false } = {}) {
  if (!teamModeOn) return false;
  if (planPropose) return false;
  if (Array.isArray(dagTasks) ? dagTasks.length > 0 : !!dagTasks) return false;
  return true;
}
